import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {Scan3dGroupModel} from '../scan3dGroup.model';
import {Scan3dConverter} from '../../../../common/api/entity/converter/scan3d.converter';
import {Scan3dGroupSummaryConverter} from './scan3dGroupSummary.converter';
import {DocumentSummaryConverter} from "../../../../../../document/common/api/converter/documentSummary.converter";

@Injectable()
export class Scan3dGroupConverter extends HttpModelConverter<Scan3dGroupModel> {

    constructor(private scan3dConverter: Scan3dConverter,
                private scan3dGroupSummaryConverter: Scan3dGroupSummaryConverter,
                private documentSummaryConverter: DocumentSummaryConverter) {
        super();
    }
    protected createInstance(): Scan3dGroupModel {
        return new Scan3dGroupModel();
    }

    protected enrichObject(result: Scan3dGroupModel, src: Scan3dGroupModel) {
        result.scans = this.scan3dConverter.convertFromArray(src.scans);
        result.summary = this.scan3dGroupSummaryConverter.convert(src.summary);
        result.scanDocument = this.documentSummaryConverter.convert(src.scanDocument);
        result.leftScanDocument = this.documentSummaryConverter.convert(src.leftScanDocument);
        result.rightScanDocument = this.documentSummaryConverter.convert(src.rightScanDocument);
        result.leftImageDocument = this.documentSummaryConverter.convert(src.leftImageDocument);
        result.rightImageDocument = this.documentSummaryConverter.convert(src.rightImageDocument);
        result.imageDocument = this.documentSummaryConverter.convert(src.imageDocument);
    }
}
